<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.paymentSummary.editPaymentSummary')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <button class="btn btn-dark my-2" @click="goBack">
                    <span class="fa fa-caret-left"></span>
                    <span class="fa fa-caret-left"></span>
                </button>

                <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Form -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.paymentSummary.editPaymentSummary')}}</div>
                        <div class="text-right">
                            <button class="btn btn-primary" @click="updateSummary()"
                                :disabled="disableEditForm || readonly">{{$t('button.update')}}</button>
                            <button class="btn btn-info" @click="updateSummary(true)"
                                :disabled="disableEditForm || readonly">{{$t('button.updateClose')}}</button>
                             <button class="btn btn-danger" @click="generate('pdf')">
                                <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.pdf')}}
                            </button>
                            <button class="btn btn-primary" @click="generate('word')">
                                <i class="fa fa-download" aria-hidden="true"></i>{{$t('button.word')}}
                            </button>
                        </div>
                    </div>

                    <div class="card-body">
                        <b-tabs content-class="mt-3">
                            <b-tab :title="$t('form.paymentSummary.tabGeneral')" active>
                                <div class="row">
                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label for="SummaryNumberField">{{$t('form.paymentSummary.summaryNumber')}}<span
                                                    class="text-danger">*</span></label>
                                            <input id="SummaryNumberField" type="text" v-model="summary.reference_number"
                                                class="form-control" required="required" disabled>
                                        </div>

                                      <div class="row">
                                          <div class="col-md-12">
                                           <div class="form-group">
                                            <label for="StudentNameField">{{$t('form.paymentSummary.student')}}<span
                                                    class="text-danger">*</span></label>
                                            <ul class="list-group m-0">
                                                <div class="input-group">
                                                    <input type="hidden" v-model="summary.student_id">
                                                    <input id="StudentNameField" type="text" class="form-control"
                                                        v-model.trim="$v.studentName.$model"
                                                        :class="{ 'is-invalid': $v.studentName.$error }" disabled>

                                                </div>
                                                <div class="invalid-feedback" v-if="!$v.studentName.required">
                                                    {{$t('form.validation.required')}}</div>

                                            </ul>
                                        </div>
                                       </div>
                                      </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>{{$t('form.paymentSummary.mailAddress')}}</label><br>
                                            <b-form-radio name="mail" v-model="summary.mail_address" value="1" :disabled="isSent">
                                                {{$t('form.paymentSummary.personalAddress')}}
                                            </b-form-radio>
                                            
                                            <b-form-radio name="mail" v-model="summary.mail_address" value="2" :disabled="isRadioDisabled" v-b-tooltip.hover.top :title="businessTooltip" style="position: relative; display: inline-block;">
                                                {{$t('form.paymentSummary.businessAddress')}}
                                            </b-form-radio>
                                            
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="TitleText">{{$t('form.paymentSummary.titleText')}}</label>
                                            <input id="TitleText" type="text" v-model="summary.title" class="form-control" :readonly="isSent">
                                        </div>

                                        <div class="form-group">
                                            <label for="IntroText">{{$t('form.paymentSummary.introText')}}</label>
                                            <input id="IntroText" type="text" v-model="summary.intro_text" class="form-control" :readonly="isSent">
                                        </div>

                                        <div class="form-group">
                                            <label for="ClosingText">{{$t('form.paymentSummary.closingText')}}</label>
                                            <input id="ClosingText" type="text" v-model="summary.closing_text" class="form-control" :readonly="isSent">
                                        </div>

                                        <div class="form-group">
                                            <b-form-checkbox 
                                                id="group-by-year" 
                                                v-model="summary.group_by_year"
                                                :disabled="isSent || summary.custom_grouping"
                                                @change="handleGroupByYearChange"
                                            >
                                                {{ $t('form.paymentSummary.groupByYear') }}
                                            </b-form-checkbox>
                                            
                                            <b-form-checkbox 
                                                id="custom-grouping" 
                                                v-model="summary.custom_grouping"
                                                :disabled="isSent || summary.group_by_year"
                                                @change="handleCustomGroupingChange"
                                            >
                                                {{ $t('form.paymentSummary.customGrouping') }}
                                            </b-form-checkbox>
                                        </div>

                                        <div class="form-group">
                                            <label for="GrandTotalLabel">{{ $t('form.paymentSummary.grandTotalLabel') }}</label>
                                            <input 
                                                id="GrandTotalLabel" 
                                                type="text" 
                                                v-model="summary.grand_total_label" 
                                                class="form-control" 
                                                :readonly="isSent"
                                                :placeholder="$t('form.paymentSummary.totalFeesPaidToDate')"
                                            />
                                        </div>

                                        <div class="form-group">
                                            <table class="table table-hover table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 40px;">
                                                            {{ $t("form.student.drag") }}
                                                        </th>
                                                        <th>
                                                            {{ $t("form.student.amountReceived") }}
                                                        </th>
                                                        <th>
                                                            {{ $t("form.student.invoiceNumber") }}
                                                        </th>
                                                        <th>
                                                            {{ $t("form.student.dateFeesReceived") }}
                                                        </th>
                                                        <th v-if="summary.group_by_year">{{ $t("form.student.year") }}</th>
                                                        <th v-if="summary.custom_grouping">{{ $t("form.student.groupNumber") }}</th>
                                                        <th class="text-center" style="width: 100px;">
                                                            {{ $t("form.student.sort_order") }}
                                                        </th>
                                                        <th v-if="!isSent" class="text-right">
                                                            {{ $t("form.student.action") }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(row, idx) in paymentSummaryItems">
                                                        <!-- Group Separator -->
                                                        <tr v-if="idx === 0 || getGroupKey(row) !== getGroupKey(paymentSummaryItems[idx-1])" class="table-secondary">
                                                            <td v-if="summary.group_by_year || summary.custom_grouping" colspan="100" class="py-1 text-center text-muted">
                                                                <strong>Group: {{ getGroupKey(row) === 'no_year' ? 'No Year' : getGroupKey(row) }}</strong>
                                                            </td>
                                                        </tr>
                                                        <tr :key="row.id || row.invoice_number || idx" class="draggable-row" :draggable="!isSent" @dragstart="onDragStart($event, row)" @dragover="onDragOver" @drop="onDrop($event, row)">
                                                            <td class="text-center align-middle" style="cursor: grab;" :readonly="isSent">⋮⋮</td>
                                                            <td>
                                                                <input type="number" step="0.01" v-model.number="row.amount_received" class="form-control" :readonly="isSent" />
                                                            </td>
                                                            <td>
                                                                <input type="text" v-model="row.invoice_number" class="form-control" :readonly="isSent" />
                                                            </td>
                                                            <td>
                                                                <date-picker
                                                                    class="date-picker"
                                                                    :lang="lang"
                                                                    v-model="row.payment_date"
                                                                    valueType="format"
                                                                    :format="dateFormat"
                                                                    :popup-style="{ top: '100%', left: 0 }"
                                                                    :append-to-body="false"
                                                                    :disabled="isSent"
                                                                    @input="autoPopulateYear(row, idx)"
                                                                >
                                                                </date-picker>
                                                            </td>

                                                            <td v-if="summary.group_by_year">
                                                                <input 
                                                                    type="text" 
                                                                    v-model="row.year" 
                                                                    maxlength="4" 
                                                                    class="form-control" 
                                                                    :placeholder="$t('form.student.year')"
                                                                    :readonly="isSent"
                                                                    @blur="sortPaymentSummaryItemsByYear"
                                                                />
                                                            </td>

                                                            <td v-if="summary.custom_grouping">
                                                                <input 
                                                                    type="number" 
                                                                    v-model.number="row.group_number" 
                                                                    min="1"
                                                                    class="form-control" 
                                                                    :placeholder="$t('form.student.groupNumber')"
                                                                    :readonly="isSent"
                                                                    @blur="sortPaymentSummaryItemsByGroup"
                                                                />
                                                            </td>

                                                            <td class="text-center align-middle" :readonly="isSent">
                                                                <div class="d-flex align-items-center justify-content-center">
                                                                    <button class="btn btn-sm btn-outline-secondary" :disabled="getGroupItems(row).indexOf(row) === 0" @click="moveRowUp(row)">↑</button>
                                                                    <span class="mx-1">{{ row.sort_order || 1 }}</span>
                                                                    <button class="btn btn-sm btn-outline-secondary" :disabled="getGroupItems(row).indexOf(row) === getGroupItems(row).length - 1" @click="moveRowDown(row)">↓</button>
                                                                </div>
                                                            </td>
                                                            
                                                            <td v-if="!isSent" class="text-right">
                                                                <button class="btn btn-danger btn btn-sm" @click="removeRow(idx)">
                                                                <span class="fa fa-trash"></span>
                                                                </button>
                                                            
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                                <tfoot v-if="!isSent">
                                                    <tr>
                                                    <td></td><td></td>
                                                    <td></td><td></td>
                                                    <td></td>
                                                    <td v-if="summary.group_by_year"></td>
                                                    <td v-if="summary.custom_grouping"></td>
                                                    <td class="text-right">
                                                        <button class="btn btn-success" @click="addRow"><span class="fa fa-plus"></span>
                                                        </button>
                                                    </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>

                                        <div class="form-group" v-if="summary.group_by_year && paymentSummaryItems.length">
                                            <label>{{ $t('form.paymentSummary.subtotalLabels') }}</label>
                                            <div v-for="year in getUniqueYears()" :key="year" class="mb-2">
                                                <label class="font-weight-bold">
                                                    {{ $t('form.paymentSummary.subtotalText') }} 
                                                    <span v-if="year === 'noYear'">{{ $t('form.paymentSummary.noYear') }}</span>
                                                    <span v-else>{{ year }}</span>
                                                </label>
                                                <input 
                                                    type="text" 
                                                    v-model="subtotalLabelsInput[year]" 
                                                    class="form-control" 
                                                    :readonly="isSent"
                                                    :placeholder="getSubtotalPlaceholder(year, 'year')"
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group" v-if="summary.custom_grouping && paymentSummaryItems.length">
                                            <label>{{ $t('form.paymentSummary.subtotalLabels') }}</label>
                                            <div v-for="group in getUniqueGroups()" :key="group" class="mb-2">
                                                <label class="font-weight-bold">
                                                    {{ $t('form.paymentSummary.subtotalText') }} 
                                                    <span v-if="group === 'unspecified'">{{ $t('form.paymentSummary.unspecifiedGroup') }}</span>
                                                    <span v-else>{{ $t('form.paymentSummary.group') }} {{ group }}</span>
                                                </label>
                                                <input 
                                                    type="text" 
                                                    v-model="subtotalLabelsInput[group]" 
                                                    class="form-control" 
                                                    :readonly="isSent"
                                                    :placeholder="getSubtotalPlaceholder(group, 'group')"
                                                />
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label>{{$t('form.paymentSummary.totalAmount')}}<span class="text-danger">*</span></label>
                                            <input v-model="totalAmountFormatted" class="form-control" :disabled="disableAmount">
                                        </div>

                                        <div class="form-group">
                                            <label>{{$t('form.paymentSummary.currency')}} <span
                                                    class="text-danger">*</span></label>
                                            <v-select :options="currencies" v-model.trim="$v.summary.currency.$model" :reduce="currencies => currencies" :key="summary.currency" :disabled="isSent">
                                            </v-select>
                                            <div class="invalid-feedback custom-validate" v-if="invalidCurrency">
                                                {{$t('form.validation.required')}}</div>
                                        </div>

                                        <div class="form-group">
                                            <label>{{$t('form.paymentSummary.summaryDate')}} <span
                                                    class="text-danger">*</span></label>

                                            <date-picker :lang="lang" class="date-picker" v-model="summary.summary_date" valueType="format" :format="dateFormat" :popup-style="{ top: '100%', left: 0}" :append-to-body="false" :disabled="isSent">
                                            </date-picker>
                                            <div class="invalid-feedback custom-validate" v-if="invalidDate">
                                                {{$t('form.validation.required')}}</div>
                                        </div>

                                       
                                        
                                        <div class="form-group">
                                            <b-form-checkbox id="send-summary" v-model="summary.send_summary"
                                            :disabled="readOnlySend">
                                                {{$t('form.paymentSummary.sendPaymentSummary')}}
                                            </b-form-checkbox>
                                        </div>
                                        <div class="form-group" v-if="summary.send_summary==true">
                                            <label>{{$t('form.paymentSummary.scheduledDeliveryDate')}}</label>
                                            <date-picker :lang="lang" class="date-picker" v-model="ScheduledSummaryDeliveryDate"
                                                valueType="format" type="datetime" :format="datetimeFormat"
                                                :disabled="readOnlyDelivery" :popup-style="{ left: 0}"
                                                :append-to-body="false">
                                            </date-picker>
                                        </div>
                                        <div class="form-group" v-if="summary.send_summary==true && summary.status=='Sent'">
                                            <label>{{$t('form.paymentSummary.deliveryDate')}}</label>
                                            <date-picker :lang="lang" class="date-picker" v-model="summary.sent_at"
                                                valueType="format" type="datetime" :format="datetimeFormat"
                                                disabled :popup-style="{left: 0}"
                                                :append-to-body="false">
                                            </date-picker>
                                        </div>
                                        <div class="form-group">
                                            <label>{{$t('form.paymentSummary.status')}}</label>
                                            <v-select @input="selectedStatus" :label="selected_status"
                                            v-model="selected_status" :options="statusArray" :reduce="statusArray => statusArray"></v-select>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required,
        decimal
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'editFormInterval', 'dateFormat', 'datetimeFormat', 'decimalDigits'],

        data() {
            return {

                alert: false,
                alertClass: '',
                alertMessage: '',
                updated:false,
                isLoading: false,
                fullPage: true,
                request_source: '',
                invalidCurrency: false,
                invalidDate: false,
                readOnlyDelivery: false,
                readOnlySend: false,
                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,
                closing: true,
                disableAmount: true,
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },

                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,

                studentName: '',
                summary: {
                    student_id: '',
                    reference_number: '',
                    mail_address: 1,
                    title: '',
                    intro_text: '',
                    closing_text: '',
                    total_amount: 0,
                    currency: 'CHF',
                    summary_date: '',
                    send_summary: 0,
                    sent_at: null,
                    status: '',
                    group_by_year: false,
                    custom_grouping: false,
                    grand_total_label: 'Total fees paid to date:',
                    subtotal_labels: {}
                },
                paymentSummaryItems: [],
                ScheduledSummaryDeliveryDate: '',
                selected_status: 'Pending',
                currencies: [],
                business: [],
                StudentNumber: '',
                availableFormats: ['pdf', 'word'],
                timezone:'Europe/Zurich',
                status:null,
                statusArray:[],
                routeToMove:'PaymentSummariesPendingIndex',
                subtotalLabelsInput: {}
            }

        },

        validations: {
            summary: {
                total_amount: {
                    required,
                    decimal
                },
                currency: {
                    required
                },
                summary_date: {
                    required
                },

            },
            studentName: {
                required
            },
        },

        watch: {
            'summary.send_summary'(newVal) {
                if (newVal === true) {
                    // Only set if empty
                    if (!this.ScheduledSummaryDeliveryDate) {
                        this.ScheduledSummaryDeliveryDate = moment().format(this.datetimeFormat);
                    }
                } else {
                    // Clear date when unchecked
                    this.ScheduledSummaryDeliveryDate = null;
                }
            },

            'summary.group_by_year'(newValue) {
                if (newValue) {
                    // 1. Clear custom grouping
                    this.summary.custom_grouping = false;
                    this.paymentSummaryItems.forEach(item => { item.group_number = null; });

                    // 2. Populate years for existing items
                    this.paymentSummaryItems.forEach((item, idx) => {
                        if (item.payment_date && !item.year) {
                            this.autoPopulateYear(item, idx);
                        }
                    });

                    // 3. Sort and RESET sort_order to 1, 2, 3...
                    this.sortPaymentSummaryItemsByYear();
                    this.resortItems();
                }
            },

            'summary.custom_grouping'(newValue) {
                if (newValue) {
                    // 1. Clear year grouping
                    this.summary.group_by_year = false;
                    this.paymentSummaryItems.forEach(item => { item.year = null; });

                    // 2. Sort and RESET sort_order to 1, 2, 3...
                    this.sortPaymentSummaryItemsByGroup();
                    this.resortItems();
                }
            },
        },

        async mounted() {
            if (!this.permissions.viewInvoicesStudents) {
                return this.$router.push('/');
            }

            if (this.permissions.editInvoicesStudents) {
                this.checkForEdit();
                let self = this;

                this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);
            }
            this.isLoading = true;

            await this.getInitialData();
            await this.getStatusAndTimeZone();
            await this.getPaymentSummary();
            this.closing = true;
        },

        computed: {
            totalAmount() {
                return this.paymentSummaryItems.reduce((sum, item) => {
                    return sum + (parseFloat(item.amount_received) || 0);
                }, 0);
            },

            totalAmountFormatted() {
                return toThousandSeparator(this.totalAmount);
            },

            isRadioDisabled() {
                if(this.selected_status === 'Sent') {
                    return true;
                }
                return !(this.business.CompanyName && this.business.StreetAddress && this.business.City && this.business.Zip && this.business.Email);
            },
            businessTooltip() {
            if (!(this.business.CompanyName && this.business.StreetAddress && this.business.City && this.business.Zip && this.business.Email)) {
                return 'Student has no business address specified.';
                } else {
                    return '';
                }
            },

            SummaryDeliveryDate(){

            var SummaryDeliveryDate = this.summary.delivery_date?(moment(this.summary.delivery_date, this.datetimeFormat,true).isValid()?this.summary.delivery_date:moment(this.summary.delivery_date).format(this.datetimeFormat)):this.ScheduledSummaryDeliveryDate
            return SummaryDeliveryDate;
            },

            readonly() {
                return !this.permissions.editInvoicesStudents;
            },

            isSent() {
                return this.selected_status === 'Sent';
            },
        },

        methods: {
            handleGroupByYearChange() {
                if (this.summary.group_by_year) {
                    this.summary.custom_grouping = false;
                    // Clear group numbers when switching to year grouping
                    this.paymentSummaryItems.forEach(item => {
                        item.group_number = null;
                    });
                }
            },

            handleCustomGroupingChange() {
                if (this.summary.custom_grouping) {
                    this.summary.group_by_year = false;
                    // Clear years when switching to custom grouping
                    this.paymentSummaryItems.forEach(item => {
                        item.year = null;
                    });
                }
            },

            autoPopulateYearOrGroup(row, idx) {
                if (this.summary.group_by_year) {
                    this.autoPopulateYear(row, idx);
                }
            },

            sortPaymentSummaryItemsByGroup() {
                if (!this.summary.custom_grouping) {
                    return;
                }

                this.paymentSummaryItems.sort((a, b) => {
                    const groupA = a.group_number !== null && a.group_number !== undefined && a.group_number !== '' ? parseInt(a.group_number) : null;
                    const groupB = b.group_number !== null && b.group_number !== undefined && b.group_number !== '' ? parseInt(b.group_number) : null;

                    // If both have group numbers, sort ascending
                    if (groupA !== null && groupB !== null) {
                        return groupA - groupB;
                    }

                    // If only A has group number, A comes first
                    if (groupA !== null && groupB === null) {
                        return -1;
                    }

                    // If only B has group number, B comes first
                    if (groupA === null && groupB !== null) {
                        return 1;
                    }

                    // If neither has group number, maintain original order
                    return 0;
                });
            },

            getUniqueGroups() {
                const groups = new Set();
                let hasUnspecified = false;

                this.paymentSummaryItems.forEach(item => {
                    if (item.group_number !== null && item.group_number !== undefined && item.group_number !== '') {
                        groups.add(item.group_number);
                    } else {
                        hasUnspecified = true;
                    }
                });

                // Sort groups ascending and add 'unspecified' at the end
                const result = Array.from(groups).sort((a, b) => a - b);
                if (hasUnspecified) {
                    result.push('unspecified');
                }

                return result;
            },

            getSubtotalPlaceholder(value, type) {
                if (type === 'year') {
                    if (value === 'noYear') {
                        return this.$t('form.paymentSummary.totalFeesPaid');
                    }
                    return this.$t('form.paymentSummary.totalFeesForYear', {year: value});
                } else if (type === 'group') {
                    if (value === 'unspecified') {
                        return this.$t('form.paymentSummary.totalFeesPaid');
                    }
                    return this.$t('form.paymentSummary.totalFeesForGroup', {group: value});
                }
                return this.$t('form.paymentSummary.totalFeesPaid');
            },
            
            sortPaymentSummaryItemsByYear() {
                if (!this.summary.group_by_year) {
                    return;
                }

                this.paymentSummaryItems.sort((a, b) => {
                    const yearA = a.year && a.year.trim() !== '' ? a.year : null;
                    const yearB = b.year && b.year.trim() !== '' ? b.year : null;

                    // If both have years, sort ascending
                    if (yearA && yearB) {
                        return yearA.localeCompare(yearB);
                    }

                    // If only A has year, A comes first
                    if (yearA && !yearB) {
                        return -1;
                    }

                    // If only B has year, B comes first
                    if (!yearA && yearB) {
                        return 1;
                    }

                    // If neither has year, maintain original order
                    return 0;
                });
            },

            autoPopulateYear(row, idx) {
                if (!this.summary.group_by_year) {
                    return;
                }

                if (row.payment_date) {
                    let year = '';

                    // Handle different date formats
                    if (typeof row.payment_date === 'string') {
                        // If it's a string like "03.05.2024" (DD.MM.YYYY)
                        const parts = row.payment_date.split('.');
                        if (parts.length === 3) {
                            year = parts[2]; // Get year from DD.MM.YYYY
                        } else {
                            // Try moment parsing
                            const momentDate = moment(row.payment_date, this.dateFormat);
                            if (momentDate.isValid()) {
                                year = momentDate.format('YYYY');
                            }
                        }
                    } else if (row.payment_date instanceof Date) {
                        year = row.payment_date.getFullYear().toString();
                    } else {
                        // Try moment parsing as fallback
                        const momentDate = moment(row.payment_date);
                        if (momentDate.isValid()) {
                            year = momentDate.format('YYYY');
                        }
                    }

                    if (year && year.length === 4 && !isNaN(year)) {
                        this.$set(this.paymentSummaryItems[idx], 'year', year);
                        
                        // Re-sort after year is populated
                        this.sortPaymentSummaryItemsByYear();
                    }
                }
            },

            getUniqueYears() {
                const years = new Set();
                let hasNoYear = false;

                this.paymentSummaryItems.forEach(item => {
                    if (item.year && item.year.trim() !== '' && item.year.length === 4) {
                        years.add(item.year);
                    } else {
                        hasNoYear = true;
                    }
                });

                // Sort years ascending and add 'noYear' at the end
                const result = Array.from(years).sort((a, b) => a.localeCompare(b));
                if (hasNoYear) {
                    result.push('noYear');
                }

                return result;
            },

            addRow() {
                this.paymentSummaryItems.push({
                    id: null,
                    invoice_number: '',
                    amount_received: 0,
                    payment_date: null,
                    is_manual: true, 
                    sort_order: this.paymentSummaryItems.length + 1
                });
            },
            removeRow(idx) {
                if (this.paymentSummaryItems.length === 1) {
                    alert('At least one payment row is required.');
                    return;
                }

                this.paymentSummaryItems.splice(idx, 1);
            },
            getGroupKey(item) {
                if (!item) return null; // Handle undefined
                const isYear = this.summary?.group_by_year || this.studentPaymentSummary?.GroupByYear;
                const isCustom = this.summary?.custom_grouping || this.studentPaymentSummary?.CustomGrouping;
                if (isYear) return item.year || 'no_year';
                if (isCustom) return item.group_number?.toString() || 'unspecified';
                return null;
            },

            getGroupItems(item) {
                const key = this.getGroupKey(item);
                if (!key) return this.paymentSummaryItems;
                return this.paymentSummaryItems.filter(i => this.getGroupKey(i) === key);
            },

            moveRowUp(item) {
                const group = this.getGroupItems(item);
                const idx = group.indexOf(item);
                if (idx > 0) {
                    const prev = group[idx - 1];
                    // Swap sort_order
                    const temp = item.sort_order || 0;
                    this.$set(item, 'sort_order', prev.sort_order || 0);
                    this.$set(prev, 'sort_order', temp);
                    // Re-sort and re-index
                    this.resortItems();
                }
            },

            moveRowDown(item) {
                const group = this.getGroupItems(item);
                const idx = group.indexOf(item);
                if (idx < group.length - 1) {
                    const next = group[idx + 1];
                    // Swap sort_order
                    const temp = item.sort_order || 0;
                    this.$set(item, 'sort_order', next.sort_order || 0);
                    this.$set(next, 'sort_order', temp);
                    // Re-sort and re-index
                    this.resortItems();
                }
            },

            resortItems() {
                const isYear = this.summary?.group_by_year;
                const isCustom = this.summary?.custom_grouping;

                // 1. Sort the array
                this.paymentSummaryItems.sort((a, b) => {
                    const keyA = this.getGroupKey(a);
                    const keyB = this.getGroupKey(b);
                    
                    // If not grouped, just sort by sort_order
                    if (!isYear && !isCustom) {
                        return (a.sort_order || 0) - (b.sort_order || 0);
                    }

                    // Sort by group first
                    if (keyA !== keyB) {
                        if (keyA === 'unspecified' || keyA === 'no_year') return 1;
                        if (keyB === 'unspecified' || keyB === 'no_year') return -1;
                        return keyA - keyB;
                    }
                    // Then by sort_order
                    return (a.sort_order || 0) - (b.sort_order || 0);
                });

                // 2. Re-index sort_order to be sequential (1, 2, 3...) within groups
                // We must track the current group to reset the counter
                let currentGroup = null;
                let counter = 1;

                this.paymentSummaryItems.forEach(item => {
                    const itemGroup = this.getGroupKey(item);
                    
                    if (itemGroup !== currentGroup) {
                        currentGroup = itemGroup;
                        counter = 1; // Reset counter for new group
                    }
                    
                    this.$set(item, 'sort_order', counter);
                    counter++;
                });
            },

            // Drag & Drop Handlers
            onDragStart(event, item) {
                event.dataTransfer.setData('text/plain', item.invoice_number || item.amount_received);
                this.draggingItem = item;
                event.target.style.opacity = '0.5';
            },

            onDragOver(event) {
                event.preventDefault();
            },

            onDrop(event, targetItem) {
                event.preventDefault();
                if (!this.draggingItem || this.draggingItem === targetItem) return;

                // Restrict drag & drop to same group
                if (this.getGroupKey(this.draggingItem) !== this.getGroupKey(targetItem)) {
                    return;
                }

                // Swap sort_order values
                const temp = this.draggingItem.sort_order || 0;
                this.$set(this.draggingItem, 'sort_order', targetItem.sort_order || 0);
                this.$set(targetItem, 'sort_order', temp);

                // Re-sort and re-index everything to ensure clean 1,2,3 sequence
                this.resortItems();
                
                this.draggingItem = null;
                document.querySelectorAll('.draggable-row').forEach(el => el.style.opacity = '1');
            },
            goBack() {
                const origin = this.$route.query.origin;

                if (origin === 'student') {
                    this.$router.push({
                        name: 'StudentEdit',
                        params: { id: this.StudentNumber }
                    });
                    return;
                }

                if (origin === 'alumni') {
                    this.$router.push({
                        name: 'AlumniEdit',
                        params: { id: this.StudentNumber }
                    });
                    return;
                }

                if (origin === 'payment-summaries') {
                    this.$router.push({
                        name: 'PaymentSummariesIndex'
                    });
                }

                if (origin === 'pending-payment-summaries') {
                    this.$router.push({
                        name: 'PaymentSummariesPendingIndex'
                    });
                }
            },
            /* Remove formatting from summary Amount  */
            removeFormatting(amount)
            {
                return removeThousandSeparator(amount);

            },
            applyFormatting()
            {
                return toThousandSeparator(amount);
            },

            emptyDeliveryDate(){
            this.ScheduledSummaryDeliveryDate = null
            },

            getDate(date){
                var dateVar  = date?date:moment().format(this.datetimeFormat)
                return dateVar;
            },

            async generate(type = null) {
                if (!this.availableFormats.includes(type)) return;

                let token = await this.createToken('student-payment-summary');
                if (token == '') return;

                window.open(`/payment-summaries/${this.$route.params.id}/${type}?token=${token}`, '_blank');
            },

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {type});
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async getStatusAndTimeZone() {
                try{
                var self = this;
                const response = await axios.get('/api/config');
                if (response.data) {
                    let config = response.data;
                    self.status = config.payment_summary_status;
                    self.timezone = config.timezone;
                    if (( typeof self.status == 'object') && (self.status != '')) {
                            self.statusArray = Object.values(self.status);
                    }
                }
                }catch(error){
                    console.log('error in fetching config values');
                    this.isLoading = false;
                };
            },

            getInitialData() {
                this.isLoading = true;

                axios
                    .get('/api/invoices/get-initial-data')
                    .then(response => {
                        this.currencies = response.data.currencies;
                        this.perPageAudits = response.data.auditsPaginate;


                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            selectedStatus(selected_status){
                this.summary.status = selected_status;
            },

            convertTZ(date, timezone)
            {
                var s = date.toLocaleString(undefined, { timeZone: this.timezone })
                if(typeof s == "string"){
                    s = new Date(s)
                }
                var formatteddate = moment(s).format(this.datetimeFormat)
                return formatteddate;
            },

            async getPaymentSummary()
            {
                try{
                const response = await axios.get(`/api/payment-summaries/${this.$route.params.id}/edit`);
                    if(response.data.data)
                    {
                        this.isLoading = false;
                        const data = response.data.data;
                        this.summary = {
                            id: data.id,
                            student_id: data.student_id,
                            reference_number: data.reference_number,
                            title: data.title,
                            intro_text: data.intro_text,
                            closing_text: data.closing_text,
                            summary_date: moment(data.summary_date).format(this.dateFormat),
                            status: data.status,
                            currency: data.currency,
                            mail_address: data.mail_address,
                            send_summary: data.send_summary,
                            send_status: data.send_status,
                            sent_at: data.sent_at ? moment(data.sent_at).format(this.datetimeFormat) : null,
                            delivery_date: data.delivery_date ? moment(data.delivery_date).format(this.datetimeFormat) : null,
                            group_by_year: data.group_by_year || false,
                            custom_grouping: data.custom_grouping || false,
                            grand_total_label: data.grand_total_label || 'Total fees paid to date:',
                            subtotal_labels: data.subtotal_labels || {}
                        };

                        this.paymentSummaryItems = data.items.map(item => ({
                            id: item.id,
                            invoice_number: item.invoice_number,
                            amount_received: Number(item.amount_received),
                            payment_date: item.payment_date
                                ? moment(item.payment_date).format(this.dateFormat)
                                : null,
                            is_manual: item.is_manual,
                            year: item.year || (item.payment_date ? moment(item.payment_date).format('YYYY') : null),
                            group_number: item.group_number || null,
                            sort_order: item.sort_order
                        }));

                        this.resortItems();

                        if (data.custom_grouping) {
                            this.sortPaymentSummaryItemsByGroup();
                        }

                        // Initialize subtotal labels input
                        this.subtotalLabelsInput = { ...this.summary.subtotal_labels };

                        this.summary.send_summary = data.send_summary !== 0;

                        this.selected_status = data.status;

                        this.ScheduledSummaryDeliveryDate = data.delivery_date;

                        if (this.ScheduledSummaryDeliveryDate)
                        {
                            this.ScheduledSummaryDeliveryDate = moment(this.ScheduledSummaryDeliveryDate).format(this
                                .datetimeFormat);

                            const date = this.convertTZ(new Date(), this.timezone);

                            if((this.ScheduledSummaryDeliveryDate <= date) && data.status == 'Sent')
                            {
                                if (data.send_summary)
                                {
                                    this.readOnlySend = true;
                                }

                                this.readOnlyDelivery = true;
                            }
                        }

                        /* Student Business */
                        this.business = data.student.StudentBusiness;

                        /* Student */
                        const student = data.student;
                        this.StudentNumber = student.StudentNumber;
                        this.studentName = `${student.StudentNumber} - ${student.FirstName} ${student.LastName}`;

                        this.isLoading = false;
                        this.closing = true;
                    }


                }
                catch(error)
                {
                    console.log(error);
                }
            },

            checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {
                        this.sessionCreated = true;
                        if (response.data.warning == 0) {
                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },

            clear() {
                alert(this.$t('form.validation.cannotAllowed'));
            },

            updateSummary(shouldClose = false) {
                if (this.disableEditForm) return;

                this.isLoading = true;

                const payload = {
                    ...this.summary,
                    group_by_year: this.summary.group_by_year,
                    custom_grouping: this.summary.custom_grouping,
                    grand_total_label: this.summary.grand_total_label,
                    subtotal_labels: this.subtotalLabelsInput,
                    paymentSummaryItems: this.paymentSummaryItems.map(item => ({
                        ...item,
                        year: item.year || null,
                        group_number: item.group_number || null,
                        sort_order: item.sort_order || 0
                    }))
                };

                payload.status = this.selected_status;
                payload.delivery_date = this.ScheduledSummaryDeliveryDate;

                axios
                    .put(`/api/payment-summaries/${this.$route.params.id}`, payload)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);
                            this.updated = true;

                            if (shouldClose) {
                                clearInterval(this.interval);
                                setTimeout(() => this.goBack(), 2000);
                                return;
                            }

                            this.closing = true;
                        }
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        },

        beforeRouteLeave(to, from, next) {
            clearInterval(this.interval);

            if (this.closing || this.updated){
                next();
            }else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next();
                } else {
                    next(false);
                }
            }
        }
    }

</script>
<style scoped>
    .custom-validate {
        display: block !important;
    }
</style>